import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		chipContainer: {
			marginTop: 10
		},
		numberChip: {
			marginBottom: 10,
		},
		  addButton: {
			marginLeft: 10
		  },
	} satisfies Record<string, CSSObject>;
};